var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.value ? 'fas fa-check text-success' : 'fas fa-times text-danger', _vm.size]})
}
var staticRenderFns = []

export { render, staticRenderFns }